var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 17 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter-ico",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.799805 0.75C0.799805 0.335787 1.13559 0 1.5498 0H15.6498C16.064 0 16.3998 0.335787 16.3998 0.75V1.05C16.3998 1.46421 16.064 1.8 15.6498 1.8H1.5498C1.13559 1.8 0.799805 1.46421 0.799805 1.05V0.75ZM0.799805 5.55C0.799805 5.13579 1.13559 4.8 1.5498 4.8H12.0498C12.464 4.8 12.7998 5.13579 12.7998 5.55V5.85C12.7998 6.26421 12.464 6.6 12.0498 6.6H1.5498C1.13559 6.6 0.799805 6.26421 0.799805 5.85V5.55ZM1.5498 9.6C1.13559 9.6 0.799805 9.93579 0.799805 10.35V10.65C0.799805 11.0642 1.13559 11.4 1.5498 11.4H7.2498C7.66402 11.4 7.9998 11.0642 7.9998 10.65V10.35C7.9998 9.93579 7.66402 9.6 7.2498 9.6H1.5498Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.2aec797537b651a14a887b3ac460926c.svg";
export { ForwardRef as ReactComponent };